import { formatPrefix } from 'd3-format'

export function buildFormatter(initialValue, specification = ',.1', suffix = 'B') {
  const formatter = formatPrefix(specification, initialValue)

  return (v) => {
    if (v === null) {
      return '∞'
    }

    return formatter(v) + suffix
  }
}

export function format(initialValue, specification, suffix) {
  return buildFormatter(initialValue, specification, suffix)(initialValue)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/util/Bandwidth.js